"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function generateThumbnail(videoSrc, timeInSeconds) {
  return new Promise(function (resolve, reject) {
    var video = document.createElement('video');
    video.crossOrigin = 'anonymous'; // Necessary for CORS-enabled videos

    video.src = videoSrc;
    video.currentTime = timeInSeconds; // Set the time to capture the desired frame

    video.addEventListener('loadeddata', function () {
      var canvas = document.createElement('canvas');
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
      var dataURL = canvas.toDataURL('image/jpeg'); // Change format if needed

      resolve(dataURL);
    });
    video.addEventListener('error', reject);
  });
}

var _default = generateThumbnail;
exports.default = _default;